import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CheckClientsReqModel } from '../../../models/comprobar-clientes-req.model';
import { CheckClientsResModel } from '../../../models/comprobar-clientes-res.model';
import { NgxHttpClientExtraOptions } from 'ngx-httpclient';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComprobarClientesService {

  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description comprobar clientes
   * @params data
   */
  getCheckClients(data: CheckClientsReqModel): Observable<CheckClientsResModel> {
    const httpOpt: NgxHttpClientExtraOptions | any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
    };
    const obj: any = data;
    httpOpt.params = new HttpParams({ fromObject: obj });

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.comprobarClientes.name,
      httpOpt
    ).pipe(
      map((el: any) => new CheckClientsResModel(el))
    );

  }
  /**
   * @description recuperar clientes
   * @params id
   */
  getClientes(id: any): Observable<ArrayBuffer> {
    const httpOpt: NgxHttpClientExtraOptions | any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
    };
    const obj: any = {
      documento: id
    };
    httpOpt.params = new HttpParams({ fromObject: obj });

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.Clientes.name,
      httpOpt
    );
  }
}
